// @flow

import styled from 'styled-components'

export default styled.div`
  padding: 10px 20px;
`



// WEBPACK FOOTER //
// ./src/Components/Steppers.js